export default "__VITE_ASSET__B42G6m80__"